import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { catchError, finalize, map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { ETypeSubstrat } from '../domain/MPCE/enum/type-substrat';
import { Process } from '../domain/MPCE/process';
import { Substrat } from '../domain/MPCE/substrat';
import { SampleTakingModel } from '../models/new-substrat-model';
import { CoreData } from '../tools/core-data';
import { LoadingTask } from '../tools/loading-task';
import { BaseService } from './base-service';
import { UserService } from './user-service';
import { MatSnackBar } from '@angular/material/snack-bar';

@Injectable({
    providedIn: 'root'
})
export class MPCEService extends BaseService {
    private serviceUrl = `${environment.serviceMainBaseUrl}api/MPCEProcess`;
    constructor(
        protected http: HttpClient,
        protected coreData: CoreData,
        protected loadingTask: LoadingTask,
        protected snackBare: MatSnackBar,
        protected router: Router,
        ) {
            super(coreData, router, snackBare);
    }

    getStation(code: string) {
        this.loadingTask.activateLoading();
        return this.http.get(`${this.serviceUrl}/${code}/station`, this.generateHeader()).pipe(
            catchError(this.handleError<any>('getStation')),
            finalize(() => this.loadingTask.deactivateLoading()),
            map((response: Process) => {
                return Process.mapFromJSON(response);
            }));
    }

    getGroupement(code: string) {
        this.loadingTask.activateLoading();
        return this.http.get(`${this.serviceUrl}/${code}/GroupementPrelevement`, this.generateHeader()).pipe(
            catchError(this.handleError<any>('getGroupement')),
            finalize(() => this.loadingTask.deactivateLoading()),
            map(x => x));
    }

    updateStation(process: Process) {
        this.loadingTask.activateLoading();
        return this.http.put(`${this.serviceUrl}/${process.Code}/station`, process, this.generateHeader()).pipe(
            catchError(this.handleError<any>('updateStation')),
            finalize(() => this.loadingTask.deactivateLoading()),
            map(x => x));

    }

    getSubstrat(code: string) {
        this.loadingTask.activateLoading();
        return this.http.get(`${this.serviceUrl}/${code}/substrat`, this.generateHeader()).pipe(
            catchError(this.handleError<any>('getSubstrat')),
            finalize(() => this.loadingTask.deactivateLoading()),
            map((response: Substrat[]) => {
                return response.map((item: Substrat) => {
                    return Substrat.mapFromJSON(item);
                });
            }));
    }

    updateSubstrat(processCode: string, spt: SampleTakingModel) {
        this.loadingTask.activateLoading();
        return this.http.put(`${this.serviceUrl}/${processCode}/substrat/${spt.Type}`, spt, this.generateHeader()).pipe(
            catchError(this.handleError<any>('updateSubstrat')),
            finalize(() => this.loadingTask.deactivateLoading()),
            map(x => x));
    }

    updateSubstratList(processCode: string, spt: SampleTakingModel[]) {
        this.loadingTask.activateLoading();
        return this.http.put(`${this.serviceUrl}/${processCode}/substrats`, spt, this.generateHeader()).pipe(
            catchError(this.handleError<any>('updateSubstratList')),
            finalize(() => this.loadingTask.deactivateLoading()),
            map(x => x));
    }

    deleteSubstrat(processCode: string, type: ETypeSubstrat) {
        this.loadingTask.activateLoading();
        return this.http.delete(`${this.serviceUrl}/${processCode}/substrat/${type}`, this.generateHeader()).pipe(
            catchError(this.handleError<any>('deleteSubstrat')),
            finalize(() => this.loadingTask.deactivateLoading()),
            map(x => x));
    }
}
